import { useMemo, useState } from "preact/hooks";

/** Shared click-to-sort state/logic for the Demand and Kiosks tables. */
export function useSortableRows<T, K extends string>(
  rows: T[],
  sortValue: (row: T, key: K) => string,
  initialKey: K,
) {
  const [sortKey, setSortKey] = useState<K>(initialKey);
  const [sortDir, setSortDir] = useState(1);

  const sorted = useMemo(() => {
    const list = [...rows];
    list.sort((a, b) => sortValue(a, sortKey).localeCompare(sortValue(b, sortKey)) * sortDir);
    return list;
  }, [rows, sortKey, sortDir]);

  function handleSort(key: K) {
    if (key === sortKey) {
      setSortDir((d) => -d);
    } else {
      setSortKey(key);
      setSortDir(1);
    }
  }

  return { sorted, sortKey, sortDir, handleSort };
}

/** Shared "selected row + zebra stripe" class-name pattern. */
export function rowClass(selected: boolean, index: number): string | undefined {
  return [selected ? "selected-instance" : "", index % 2 === 1 ? "row-stripe" : ""].filter(Boolean).join(" ") || undefined;
}
